import services from "../services";
//import * as types from "./mutation-type";

export const ActionSaveSubscription = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.ActionSaveSubscription(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    })
}